<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getTemplateList)" class="refresh-btn">刷新</el-button>
    <div slot="content" class="templatewrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="问卷名称">
            <el-input v-model="searchForm.examTemplateName" placeholder="请输入问卷名称" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getTemplateList, searchForm)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getTemplateList, { examTemplateName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addTemplate">新增问卷</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteTemplateList">批量删除</el-button>
      </div>
      <div>
        <!-- 问卷列表 -->
        <el-table v-loading="loading" :data="templateList" :max-height="tableHeight" ref="multipleTable"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="examTemplateName" label="问卷名称" />
          <el-table-column prop="createBy" label="创建人" />
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="230">
            <template slot-scope="scope">
              <el-button icon="el-icon-delete" type="danger" @click="deleteTemplate(scope.row)">删除问卷</el-button>
              <el-button icon="el-icon-edit" type="primary" @click="$router.push('/patientfollowup/questionnairedetails?examTemplateId='
                + scope.row.examTemplateId + '&examTemplateName=' + scope.row.examTemplateName)">编辑问卷</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getTemplateList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增弹框 -->
      <el-dialog class="templateEdit" title="新建问卷" :visible.sync="dialogVisible" width="400px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="问卷名称" prop="examTemplateName">
            <el-input v-model="editForm.examTemplateName" placeholder="请输入问卷名称" />
          </el-form-item>
          <el-form-item label="题库题目" prop="examQuestionBankIds" :rules="[{ required: true, message: '选择的题目不能为空！' }]">
            <el-select v-model="editForm.examQuestionBankIds" multiple clearable placeholder="请选择问卷题目">
              <el-option v-for="item in questionOptions" :key="item.examQuestionBankId" :label="item.questionsTitle"
                :value="item.examQuestionBankId" />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script lang="js">
import { templateList, templateDelete, templateAdd, questionBankList } from "@/api/followup-questionnaire"; // 获取问卷请求
export default {
  name: "questionnaire",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { examTemplateName: null }, // 查询表单
      templateList: [], // 问卷列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      questionOptions: [], // 题库问题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      editFormRules: {
        examTemplateName: [{ required: true, message: "问卷名称不能为空！", trigger: "blur" }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320; // 计算表格最大高度
    this.getTemplateList(); // 请求问卷列表
    this.getQuestionBankList(); // 请求题库
  },
  methods: {
    // 请求所有问卷列表
    async getTemplateList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await templateList(params);
      if (code == 200) {
        this.total = total;
        this.templateList = rows;
      }
      this.loading = false;
    },
    // 请求题库
    async getQuestionBankList() {
      let { rows, code } = await questionBankList();
      if (code == 200) this.questionOptions = rows;
    },
    // 新增问卷
    addTemplate() {
      this.dialogVisible = true;
      this.editForm = { examTemplateName: null, examQuestionBankIds: [] };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.editForm.questions = [];
          this.questionOptions.forEach(item => {
            this.editForm.examQuestionBankIds.forEach(kid => {
              if (kid == item.examQuestionBankId) {
                this.editForm.questions.push({
                  questionsTitle: item.questionsTitle, questionsType: item.questionsType, templateAnswers: item.answers
                });
              }
            });
          });
          templateAdd(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增问卷成功！");
            this.dialogVisible = false;
            this.$refresh(this.getTemplateList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除问卷
    deleteTemplate(row) {
      this.$confirm('确认删除该问卷？').then(_ => { this.del(row.examTemplateId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await templateDelete(id);
      if (code == 200) this.$message.success("删除问卷成功！");
      this.$refresh(this.getTemplateList);
    },
    // 批量删除问卷
    deleteTemplateList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何问卷");
      else {
        selected.forEach(item => { selectedId.push(item.examTemplateId) });
        this.$confirm('确认删除该问卷？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.templatewrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .templateEdit {
    .el-form-item {
      width: 360px;
    }

    /deep/.el-input,
    /deep/.el-form-item__content {
      width: 280px;
    }
  }
}</style>